import { render } from "./StudyTopics.vue?vue&type=template&id=a295aa4e"
import script from "./StudyTopics.vue?vue&type=script&lang=js"
export * from "./StudyTopics.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudyTopics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a295aa4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a295aa4e', __exports__)) {
    api.reload('a295aa4e', __exports__)
  }
  
  module.hot.accept("./StudyTopics.vue?vue&type=template&id=a295aa4e", () => {
    api.rerender('a295aa4e', render)
  })

}


export default __exports__